import { module } from 'modujs';

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
    };

    document
      .querySelector('.klaviyo_form_trigger')
      .addEventListener('click', function (e) {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'UN8E4i']);
        e.preventDefault();
        e.stopPropagation();
        return false;
      });
  }
}
